module.exports = __webpack_public_path__ + "img/3.a52ed2f3.jpg";